export const PAYMENT_EXCLUDES = [2, 4, 7, 8, 11, 13]; // Remove "12" : "Website" option from payment excludes 13/08/2026
